<script>
import EggOrder from '@/sales/components/EggOrder.vue';

export default {
  components: {
    EggOrder,
  },

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    order: undefined,
  }),

  methods: {
    onOrderSaved(updatedOrder) {
      this.order = updatedOrder;
    },
  },
}
</script>

<template>
  <api-loader
    method="get"
    :url="`v1/sales/egg-orders/${encodeURIComponent(id)}`"
    @loaded="order = $event">

    <egg-order v-if="order" :order="order" @saved="onOrderSaved" />

  </api-loader>
</template>



// WEBPACK FOOTER //
// src/sales/views/EggOrderView.vue